function buildMenu (allowed) {
  if (allowed == null || allowed.includes('Documents'))  {
    return [
    {
      title: 'Documents',
      icon: 'mdi-file-document-multiple',
      items: [
        //{
        //  icon: 'mdi-file-document-multiple-outline',
        //  title: 'Document Viewer',
        //  path: '/DocDocs'
        //},
        {
          icon: 'mdi-folder-open-outline',
          title: 'File Manager',
          path: '/DocFileUpload'
        },
        {
          title: 'Document Editor',
          icon: 'mdi-pencil',
          path: '/DocHTMLEditor'
        },
        {
          title: 'Document List',
          icon: 'mdi-view-list',
          path: '/DocList'
        },
      ]
    }
  ] } else return []
}

export default buildMenu